module.exports = __webpack_public_path__ + "img/rectangle.637b9cfa.svg";